import React from 'react';
import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function ErrorBoundary() {
  const error = useRouteError();
  
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 p-4">
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold text-white">404</h1>
            <p className="text-xl text-gray-400">Page not found</p>
            <p className="text-gray-500">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <Link
              to="/home"
              className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
            >
              <Home className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>
      );
    }

    if (error.status === 401) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 p-4">
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold text-white">401</h1>
            <p className="text-xl text-gray-400">Unauthorized</p>
            <p className="text-gray-500">
              Please log in to access this page.
            </p>
            <Link
              to="/auth"
              className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
            >
              Sign In
            </Link>
          </div>
        </div>
      );
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 p-4">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold text-white">Oops!</h1>
        <p className="text-xl text-gray-400">Something went wrong</p>
        <p className="text-gray-500">
          An unexpected error has occurred. Please try again later.
        </p>
        <Link
          to="/home"
          className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
        >
          <Home className="w-4 h-4" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}
